import React, { useContext,useState } from 'react';
import Loader from './Loader';
import BtnStandard from './BtnStandard';
import AppContext from '../Context/AppContext';
import InfoGeoItem from '../libraries/InfoGeoItem';

const GeoStat = ({ data }) => {
    const { setSideComponent } = useContext(AppContext)
    const [showDetail, setShowDetail] = useState(null)
    return (
        <div className='df fdc h100'>
            <div className='mb1'>
                <BtnStandard label={"Retour"} click={() => setSideComponent(null)} />
            </div>
            {!data && (
                <div className='df aic jcc py2'>
                    <Loader />
                </div>
            )}
            {data && (
                <div className='df fdc flex1 oys'>
                    {data.map((item, item_i) => (
                        <div className='mb1' key={item_i + "geo"}>
                           <InfoGeoItem item={item} item_i={item_i} showDetail={showDetail} setShowDetail={setShowDetail} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GeoStat;